"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.List = void 0;
var react_1 = __importStar(require("react"));
var system_1 = require("../system");
var utils_1 = require("../utils");
var useListStyles = (0, system_1.makeStyles)(function (theme) { return ({
    root: __assign({ overflow: 'auto', height: '100%', width: '100%' }, theme.go.mixins.typography.Body),
    list: {
        display: 'table',
        width: '100%',
    },
}); });
var useScrolledItemStyles = (0, system_1.makeStyles)({
    scrolledItem: {
        display: 'flex',
    },
});
function ListScrolledItem(_a) {
    var scrollIntoViewFlag = _a.scrollIntoView, children = _a.children;
    var elRef = (0, react_1.useRef)();
    var scrolledItem = useScrolledItemStyles().scrolledItem;
    (0, react_1.useEffect)(function () {
        if (scrollIntoViewFlag) {
            (0, utils_1.scrollIntoView)(elRef.current);
        }
    }, [scrollIntoViewFlag]);
    return (react_1.default.createElement("div", { className: scrolledItem, ref: elRef }, children));
}
function List(_a) {
    var items = _a.items, getId = _a.getId, classes = _a.classes, selectedItems = _a.selectedItems, renderItem = _a.renderItem;
    var _b = useListStyles(), root = _b.root, list = _b.list;
    var isSelected = function (item) {
        var e_1, _a;
        if (!selectedItems)
            return false;
        var id = getId(item);
        try {
            for (var selectedItems_1 = __values(selectedItems), selectedItems_1_1 = selectedItems_1.next(); !selectedItems_1_1.done; selectedItems_1_1 = selectedItems_1.next()) {
                var x = selectedItems_1_1.value;
                var xId = typeof x === 'string' ? x : getId(x);
                if (id === xId)
                    return true;
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (selectedItems_1_1 && !selectedItems_1_1.done && (_a = selectedItems_1.return)) _a.call(selectedItems_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return false;
    };
    var firstSelected = -1;
    return (react_1.default.createElement("div", { className: (0, utils_1.cn)(root, classes === null || classes === void 0 ? void 0 : classes.root) },
        react_1.default.createElement("div", { className: (0, utils_1.cn)(list, classes === null || classes === void 0 ? void 0 : classes.list) }, items.map(function (item, i) {
            var isItemSelected = isSelected(item);
            if (isItemSelected && firstSelected === -1) {
                firstSelected = i;
            }
            return (react_1.default.createElement(ListScrolledItem, { key: getId(item), scrollIntoView: i === firstSelected }, renderItem(item, isItemSelected)));
        }))));
}
exports.List = List;
